const getters = {
  reg1DataFilled(state, get) {
    const reg1State = { ...get.reg1 };
    delete reg1State.password; // unstored field
    delete reg1State.password_confirmation; // unstored field
    delete reg1State.wants_electronic_promotions; // unstored field
    delete reg1State.privacy_policy_text; // unstored field
    delete reg1State.whatsapp_consent_text; // unstored field
    delete reg1State.positive_credit_data_consent_text; // unstored field
    const stateValues = Object.values(reg1State);
    return stateValues.every((element) => element !== null);
  },
  reg2DataFilled(state, get) {
    const reg2State = { ...get.reg2 };
    delete reg2State.home_phone; // optional field
    delete reg2State.additional_info; // optional field
    const stateValues = Object.values(reg2State);
    return stateValues.every((element) => element !== null);
  },
};

export default getters;
